import { FC } from 'react';

const Dummy: FC = () => {
	window.scrollTo({ behavior: 'smooth', top: 0 });

	return (
		<div>
			Lorem ipsum dolor sit amet consectetur adipisicing elit. Fugit molestiae
			saepe, officiis repellendus quidem architecto perferendis ab enim fuga
			quas laudantium, accusamus doloribus? Saepe laboriosam harum, magnam
			voluptatibus deserunt accusamus!
			<br />
			<br />
			Lorem ipsum dolor sit amet consectetur adipisicing elit. Porro,
			consequatur accusamus labore totam delectus nihil adipisci, quas
			dignissimos reiciendis numquam possimus pariatur ex odit praesentium
			officia. Itaque ipsa nulla consectetur!
			<br />
			<br />
			Lorem ipsum dolor sit amet consectetur adipisicing elit. Porro,
			consequatur accusamus labore totam delectus nihil adipisci, quas
			dignissimos reiciendis numquam possimus pariatur ex odit praesentium
			officia. Itaque ipsa nulla consectetur!
			<br />
			<br />
			Lorem ipsum dolor sit amet consectetur adipisicing elit. Porro,
			consequatur accusamus labore totam delectus nihil adipisci, quas
			dignissimos reiciendis numquam possimus pariatur ex odit praesentium
			officia. Itaque ipsa nulla consectetur!
			<br />
			<br />
			Lorem ipsum dolor sit amet consectetur adipisicing elit. Porro,
			consequatur accusamus labore totam delectus nihil adipisci, quas
			dignissimos reiciendis numquam possimus pariatur ex odit praesentium
			officia. Itaque ipsa nulla consectetur!
			<br />
			<br />
			Lorem ipsum dolor sit amet consectetur adipisicing elit. Porro,
			consequatur accusamus labore totam delectus nihil adipisci, quas
			dignissimos reiciendis numquam possimus pariatur ex odit praesentium
			officia. Itaque ipsa nulla consectetur!
			<br />
			<br />
			Lorem ipsum dolor sit amet consectetur adipisicing elit. Porro,
			consequatur accusamus labore totam delectus nihil adipisci, quas
			dignissimos reiciendis numquam possimus pariatur ex odit praesentium
			officia. Itaque ipsa nulla consectetur!
			<br />
			<br />
			Lorem ipsum dolor sit amet consectetur adipisicing elit. Porro,
			consequatur accusamus labore totam delectus nihil adipisci, quas
			dignissimos reiciendis numquam possimus pariatur ex odit praesentium
			officia. Itaque ipsa nulla consectetur!
			<br />
			<br />
			Lorem ipsum dolor sit amet consectetur adipisicing elit. Porro,
			consequatur accusamus labore totam delectus nihil adipisci, quas
			dignissimos reiciendis numquam possimus pariatur ex odit praesentium
			officia. Itaque ipsa nulla consectetur!
			<br />
			<br />
			Lorem ipsum dolor sit amet consectetur adipisicing elit. Porro,
			consequatur accusamus labore totam delectus nihil adipisci, quas
			dignissimos reiciendis numquam possimus pariatur ex odit praesentium
			officia. Itaque ipsa nulla consectetur!
			<br />
			<br />
			Lorem ipsum dolor sit amet consectetur adipisicing elit. Porro,
			consequatur accusamus labore totam delectus nihil adipisci, quas
			dignissimos reiciendis numquam possimus pariatur ex odit praesentium
			officia. Itaque ipsa nulla consectetur!
			<br />
			<br />
			Lorem ipsum dolor sit amet consectetur adipisicing elit. Porro,
			consequatur accusamus labore totam delectus nihil adipisci, quas
			dignissimos reiciendis numquam possimus pariatur ex odit praesentium
			officia. Itaque ipsa nulla consectetur!
			<br />
			<br />
			Lorem ipsum dolor sit amet consectetur adipisicing elit. Porro,
			consequatur accusamus labore totam delectus nihil adipisci, quas
			dignissimos reiciendis numquam possimus pariatur ex odit praesentium
			officia. Itaque ipsa nulla consectetur!
			<br />
			<br />
			Lorem ipsum dolor sit amet consectetur adipisicing elit. Porro,
			consequatur accusamus labore totam delectus nihil adipisci, quas
			dignissimos reiciendis numquam possimus pariatur ex odit praesentium
			officia. Itaque ipsa nulla consectetur!
			<br />
			<br />
			Lorem ipsum dolor sit amet consectetur adipisicing elit. Porro,
			consequatur accusamus labore totam delectus nihil adipisci, quas
			dignissimos reiciendis numquam possimus pariatur ex odit praesentium
			officia. Itaque ipsa nulla consectetur!
			<br />
			<br />
			Lorem ipsum dolor sit amet consectetur adipisicing elit. Porro,
			consequatur accusamus labore totam delectus nihil adipisci, quas
			dignissimos reiciendis numquam possimus pariatur ex odit praesentium
			officia. Itaque ipsa nulla consectetur!
		</div>
	);
};

export default Dummy;
